/* Deja Leve — largeur d'affichage et menu de navigation mobile. */
(function(){
  'use strict';

  /* =======================================================================
     1. Largeur d'affichage

     Le site est concu a largeur fixe : 1180 px, avec min-width:1180px sur le
     corps de page. En dessous de 820 px, le theme bascule sur la mise en page
     mobile (classe dj-m + dj-mobile.css). Entre les deux — 820 a 1179 px — rien
     n'etait prevu : le visiteur recevait la maquette 1180 px dans une fenetre
     plus etroite et devait defiler horizontalement. Mesure avant correction :
     280 px de debordement a 900 px de large, 80 px a 1100 px. Cela concerne les
     portables en fenetre non maximisee, l'ecran partage et les tablettes.

     Correction : conserver la maquette et la reduire pour qu'elle tienne, plutot
     que de la casser. La propriete zoom est utilisee parce qu'elle affecte
     reellement la mise en page, contrairement a transform:scale qui laisserait
     la place d'origine reservee et casserait les elements en position fixed.

     Compatibilite : Chrome, Edge, Safari, Firefox 126+. Sur un navigateur qui
     ignore zoom, on retombe exactement sur le comportement anterieur.

     Verifie empiriquement : documentElement.clientWidth reste exprime en unites
     non zoomees une fois zoom applique, le calcul ne s'auto-alimente donc pas.
     ======================================================================= */

  var LARGEUR_DESIGN = 1180;
  var SEUIL_MOBILE = 820;
  var REDUCTION_MINI = 0.55;
  var racine = document.documentElement;
  var mobileALOuverture = /\bdj-m\b/.test(racine.className);

  function ajuster(){
    if(mobileALOuverture) return;
    var large = racine.clientWidth;
    if(!large) return;

    if(large < SEUIL_MOBILE){
      if(racine.className.indexOf('dj-m') === -1){ racine.className += ' dj-m'; }
      racine.style.zoom = '';
      return;
    }
    if(racine.className.indexOf('dj-m') !== -1){
      racine.className = racine.className.replace(/\s*\bdj-m\b/g, '');
    }
    if(large >= LARGEUR_DESIGN){ racine.style.zoom = ''; return; }

    var facteur = large / LARGEUR_DESIGN;
    if(facteur < REDUCTION_MINI) facteur = REDUCTION_MINI;
    racine.style.zoom = facteur.toFixed(4);
  }

  var enAttente = false;
  function planifier(){
    if(enAttente) return;
    enAttente = true;
    (window.requestAnimationFrame || function(f){ return setTimeout(f, 16); })(function(){
      enAttente = false; ajuster();
    });
  }

  ajuster();
  window.addEventListener('resize', planifier, { passive: true });
  window.addEventListener('orientationchange', planifier, { passive: true });
  window.addEventListener('load', planifier);

  /* =======================================================================
     2. Menu de navigation mobile

     Pourquoi ce bloc existe. dj-burger.js construit le menu mobile en clonant
     les elements <button> de la navigation d'entete :

         var nav = q('nav', header);
         return Array.prototype.slice.call(nav.querySelectorAll('button'));

     Or la navigation d'entete a ete convertie en vrais liens <a> (voir
     snippets/dj-nav-patch.liquid : c'est ce qui donne des URL partageables,
     indexables, ouvrables dans un nouvel onglet). Sa selection ne trouve donc
     plus rien et le panneau s'ouvrait VIDE : sur telephone, plus aucune
     navigation, puisque la navigation de bureau est par ailleurs masquee.

     Correction : reprendre entierement la gestion du bouton. Le noeud existant
     est remplace par son clone — ce qui detache ses ecouteurs, y compris celui
     qui vidait le panneau a chaque ouverture — puis on y attache le notre. Le
     clone conserve la classe .dj-burger-btn, donc dj-burger.js ne recree pas de
     second bouton (il teste sa presence avant de construire).

     Les entrees reprennent exactement les libelles et les cibles de
     l'application. « Checklist » correspond a la section interne « newsletter ».
     ======================================================================= */

  var ENTREES = [
    ['Accueil', 'accueil'],
    ['Offres', 'offres'],
    ['Créer mon business plan', 'bppro'],
    ['Checklist', 'newsletter'],
    ['Blog', 'blog'],
    ['Contact', 'contact']
  ];

  var STYLE_ENTREE = 'display:block;text-align:left;padding:13px 10px;font-size:16.5px;' +
                     'font-weight:600;color:#1B2A4A;border-radius:10px;text-decoration:none';

  var pris = false;

  function remplir(menu){
    menu.innerHTML = '';
    var url = window.__djHref || function(){ return '/'; };
    for(var i = 0; i < ENTREES.length; i++){
      var a = document.createElement('a');
      a.setAttribute('data-dj-mobile-nav', '1');
      a.href = url(ENTREES[i][1]);
      a.textContent = ENTREES[i][0];
      a.setAttribute('style', STYLE_ENTREE);
      menu.appendChild(a);
    }
  }

  function reprendreBurger(){
    if(pris) return true;
    var bouton = document.querySelector('.dj-burger-btn');
    var menu = document.querySelector('.dj-mobile-menu');
    if(!bouton || !menu) return false;

    var neuf = bouton.cloneNode(true);
    bouton.parentNode.replaceChild(neuf, bouton);
    neuf.setAttribute('aria-expanded', 'false');

    neuf.addEventListener('click', function(ev){
      ev.preventDefault();
      ev.stopPropagation();
      var ouvert = menu.classList.contains('dj-open');
      if(ouvert){
        menu.classList.remove('dj-open');
        neuf.setAttribute('aria-expanded', 'false');
      }else{
        remplir(menu);
        menu.classList.add('dj-open');
        neuf.setAttribute('aria-expanded', 'true');
      }
    });

    /* Fermeture au clic en dehors du panneau. */
    document.addEventListener('click', function(ev){
      if(!menu.classList.contains('dj-open')) return;
      if(menu.contains(ev.target) || neuf.contains(ev.target)) return;
      menu.classList.remove('dj-open');
      neuf.setAttribute('aria-expanded', 'false');
    });

    pris = true;
    return true;
  }

  var essais = 0;
  (function tenter(){
    if(reprendreBurger()) return;
    if(++essais > 30) return;
    setTimeout(tenter, 150);
  })();
})();
